import Header from "./components/Header"
import Main from "./pages/Main"
import Directories from "./pages/Directories"
import { usePath } from "./libs/path/PathProvider"
import { useEffect } from "react"
import Files from "./fmanlibs/Files"
import { useDialog } from "./libs/dialog/DialogProvider"
import PreviewDlg from "./dialogs/PreviewDlg"
import { useSnackbar } from "./libs/dialog/SnackbarProvider"

export default function App(){
    const {hash,setHash} = usePath()
    const {openDialog} = useDialog()
    const {setSnackbar} = useSnackbar()

    const resetHash = () => setHash("")
    const preview = async (fileId:string) => {
        try {
            const file = await Files.i.get(fileId)
            openDialog({id:"preview", children:<PreviewDlg file={file}/>,  onClosed:resetHash})
        }catch(e){
            setSnackbar(e)
            setHash("")
        }
    }
    useEffect(() => {
        const [action,fileId] = hash.split("/")
        if (action=="preview" && fileId) preview(fileId)
    }, [hash])
    return <>
        <Header/>
        <div className="body flex1 flex">
            <Directories/>
            <Main/>
        </div>
    </>
}